var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_3736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_109_3736",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_109_3736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4955 5.4314C16.4955 5.60168 16.4445 5.65276 16.2742 5.65276C15.7378 5.64424 15.2015 5.64424 14.6736 5.65276C13.9585 5.65276 13.5328 6.01885 13.4902 6.72548C13.4562 7.28738 13.4817 7.8578 13.4647 8.4197C13.4562 8.62402 13.5754 8.607 13.7116 8.607C14.5204 8.607 15.3377 8.61551 16.1465 8.59848C16.3849 8.59848 16.4615 8.64957 16.4359 8.89646C16.3338 9.84148 16.2486 10.7865 16.1635 11.7315C16.1465 11.9444 16.0443 11.9869 15.857 11.9869C15.2185 11.9784 14.5715 11.9784 13.9329 11.9869C13.4732 11.9869 13.5158 11.9188 13.5158 12.3871C13.5158 15.3328 13.5073 18.287 13.5243 21.2413C13.5243 21.5563 13.4477 21.6329 13.1412 21.6244C12.0429 21.6074 10.9361 21.6074 9.83786 21.6244C9.53137 21.6329 9.48029 21.5222 9.48029 21.2498C9.4888 19.7684 9.4888 18.2785 9.4888 16.7886C9.4888 15.2817 9.48029 13.7748 9.49732 12.2679C9.49732 12.0125 9.42921 11.9358 9.1738 11.9444C8.70555 11.9614 8.2373 11.9444 7.76053 11.9529C7.57323 11.9614 7.49661 11.9018 7.50512 11.706C7.51364 10.7695 7.51364 9.82445 7.50512 8.88795C7.50512 8.70916 7.5562 8.64956 7.7435 8.64956C8.22027 8.65808 8.70555 8.63254 9.18231 8.65808C9.46326 8.67511 9.52286 8.57294 9.51434 8.31753C9.49732 7.60239 9.49732 6.88724 9.51434 6.17209C9.53137 5.29518 9.76975 4.47787 10.2891 3.77124C10.9361 2.86879 11.8726 2.46014 12.9539 2.40905C14.0606 2.35797 15.1759 2.38351 16.2912 2.375C16.4445 2.375 16.4955 2.42608 16.487 2.57933C16.487 3.53286 16.487 4.48639 16.4955 5.4314Z",
    fill: "#354EB7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_3736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5ce0a6b674ae6c64fe357c7af30ead5c.svg";
export { ForwardRef as ReactComponent };